import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleOpenContactModal } from "../redux/docuSlice";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Grid, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CreateIcon from "@mui/icons-material/Create";
import { Button } from "@mui/material";
import CreateContect from "../pages/CreateContect";
import CreateCompany from "../pages/CreateCompany";
import { setOpenCompanyModal } from "../redux/modalSlice";
import CreateNewComoany from "./CreateNewComoany";
import { useLocalStorage } from "../custom-hook/useLocalStorage";
import {
  addCompany_Redux,
  AddContect_Redux,
  portal_Redux,
} from "../redux/ak_api_helper";
import { toast } from "react-toastify";
import {
  ad_ClientAddress_Update_Action,
  ad_Json_CRMSaveUDFValues_Action,
} from "../redux/dev_aditya_action";
// import CreateCompany from '../pages/CreateCompany';

export default function CompanyModal({ open }) {
  const { getClientIdMethod } = useSelector((state) => state.ak);

  const dispatch = useDispatch();
  const reqObj = useLocalStorage("required");
  const [allClientCardData, setAllClientCardData] = useState(null);
  const [udfFieldChange, setUdfFieldChange] = useState([]);
  const [companyDetailData, setCompanyDetailData] = useState({});
  const [allAddressData, setAllAddressData] = useState([
    {
      Add1: "",
      Add2: "",
      Add3: "",
      Town: "",
      County: "",
      Postcode: "",
      Country: "",
    },
    {
      Add1: "",
      Add2: "",
      Add3: "",
      Town: "",
      County: "",
      Postcode: "",
      Country: "",
    },
    {
      Add1: "",
      Add2: "",
      Add3: "",
      Town: "",
      County: "",
      Postcode: "",
      Country: "",
    },
  ]);

  const [CompanyFormData, setCompanyFormData] = useState({
    ID: "",
    Name: "",
    TelPhoneNo: "",
    Town: "",
    MobileNo: "",
    contactEmail: "",
    "Post Code": "",
    "Address Line 1": "",
    "Address Line 2": "",
    "Address Line 3": "",
    status: "",
    PassWord: "",
    Manager: "",
    County: "",
    Country: "",
    Business: "",
    Source: "",
    Folder: [],
    OriginatorNo: getClientIdMethod,
  });

  const [contactFormData, setContactFormData] = useState({
    Add1: "",
    Add2: "",
    Add3: "",
    AssignedManager: 1,
    CActive: "Yes",
    CCode: "",
    Country: "",
    Email: reqObj.Email,
    FirstName: "",
    LastName: "",
    ManagerName: "",
    Mobile: "",
    PostCode: "",
    email: "",
    Role: "",
    Salutation: "",
    Tel: "",
    Town: "",
    accid: reqObj.agrno,
    agrno: reqObj.agrno,
    greeting: "",
    maincontact: false,
    note: "",
    password: reqObj.password,
    Company: "",
    Title: "",
  });

  const obj1 = {
    accid: reqObj.agrno,
    email: reqObj.Email,
    password: reqObj.password,
    PresetMemorableData: true,
    IssueReminders: true,
    ExcludeMessageLink: true,
    KeepSignedIn: false,
    AllowUpload: false,
    ChangeProfile: true,
    LoggedIn: false,
    Blocked: false,
    emailAddress: contactFormData.email,
    ccode: contactFormData.ID ? contactFormData.ID : "",
    clientName: CompanyFormData.Name ? CompanyFormData.Name : "",
    // ccode: "test122",
    // clientName: "test company 2",
  };

  function todayDate() {
    var today = new Date().toJSON().slice(0, 10);
    return today;
  }

  const getAddressType = (index) => {
    switch (index) {
      case 0:
        return "Main Address";
      case 1:
        return "Billing Address";
      case 2:
        return "Registered Address";
      default:
        return "Main Address";
    }
  };

  // update modal
  const HandleCompanyUpdate = async () => {
    if (!CompanyFormData.ID)
      return toast.error("There is empty any required field");
    if (!CompanyFormData.ID)
      return toast.error("There is empty any required field");
    if (Object.keys(CompanyFormData.Business) === 0)
      return toast.error("There is empty any required field");

    await CompanyCreate();
    // await HandleUpdateClientDetail();
    await handleAddressUpdate();
    await handleCreateContact();
    await HandleUpdateUdf();
    setCompanyDetailData({});
    setAllAddressData([]);
    setAllClientCardData([]);
    handleClose();
  };

  const CompanyCreate = async () => {
    console.log(CompanyFormData.Folder);
    let clientdata = {
      agrno: localStorage.getItem("agrno"),
      Email: localStorage.getItem("Email"),
      password: localStorage.getItem("password"),
      ProjectIdList:
        CompanyFormData.Folder && CompanyFormData.Folder.length > 0
          ? CompanyFormData.Folder
          : localStorage.getItem("FolderId"),
      OriginatorNo: CompanyFormData.ID ? CompanyFormData.ID : "",
      OriginatorName: CompanyFormData.Name ? CompanyFormData.Name : "",
      Address: CompanyFormData.fullAddress ? CompanyFormData.fullAddress : "",
      TelNo: CompanyFormData.TelPhoneNo ? CompanyFormData.TelPhoneNo : "",
      AlteTelNo: CompanyFormData.MobileNo ? CompanyFormData.MobileNo : "",
      Faxno: "",
      ContactName: "",
      UDF1: "",
      UDF2: "",
      UDF3: "",
      StickyNote: "",
      ContactEmail: CompanyFormData.contactEmail
        ? CompanyFormData.contactEmail
        : "",
      MParameter: "",
      CDate: todayDate(),
      BussId: CompanyFormData.Business.BussId
        ? CompanyFormData.Business.BussId
        : -1,
      SourceId: CompanyFormData.Source.SourceId
        ? CompanyFormData.Source.SourceId
        : -1,
      StatusId: CompanyFormData.status.StatusId
        ? CompanyFormData.status.StatusId
        : "8",
      Description: "",
      OrgPassword: CompanyFormData.PassWord ? CompanyFormData.PassWord : "",
      ManagerId: CompanyFormData.Manager.UserId
        ? CompanyFormData.Manager.UserId
        : localStorage.getItem("FolderId"),
      OrgActive: "Yes",
    };
    console.log(CompanyFormData, "clientdata", clientdata);
    // return;
    if (CompanyFormData.Name !== "" && CompanyFormData.contactEmail !== "") {
      await dispatch(addCompany_Redux(clientdata))
        .then(() => {
          // mainAddress(); // Call mainAddress on success
          toast.success("Company added successfully"); // Show error toast message
        })
        .catch((error) => {
          // Handle any errors if the addCompany_Redux action fails
          console.error("Failed to add contact:", error);
        });
    } else {
      // alert("Please fill all the required fields");
      toast.error("Please fill all the required fields");
    }
  };

  const handleAddressUpdate = async () => {
    const updatePromises = allAddressData.map((address, index) => {
      const addressType = getAddressType(index);
      const body = {
        ...address,
        AddressType: addressType,
        OriginatorNo: CompanyFormData.ID ? CompanyFormData.ID : "",
        AddressId: index + 1,
      };

      return new Promise((resolve, reject) => {
        dispatch(
          ad_ClientAddress_Update_Action(body, (res) => {
            if (res === "Success") {
              resolve(res); // Explicitly resolve on "Success"
            } else {
              reject(new Error("Failed to update address"));
            }
          })
        );
      });
    });

    try {
      await Promise.all(updatePromises);
      toast.success("All addresses processed successfully!");
    } catch (error) {
      console.error("Error processing documents:", error);
      if (error?.response?.data?.Message) {
        toast.error(error.response.data.Message);
      } else {
        toast.error("Failed to process some addresses.");
      }
    }
  };

  const handleCreateContact = async () => {
    // Check if mandatory fields are filled
    if (
      !contactFormData.FirstName ||
      !contactFormData.LastName ||
      !contactFormData.Email
    ) {
      toast.error("Please fill in all required fields ");
      return;
    }

    let body = {
      ...contactFormData,
      CCode: CompanyFormData.ID ? CompanyFormData.ID : "",
      Company: CompanyFormData.Name ? CompanyFormData.Name : "",
    };

    // Proceed to create contact if validation passes
    await dispatch(AddContect_Redux(body))
      .then(() => {
        // toast.success("Contact added successfully");
        setTimeout(() => {
          dispatch(portal_Redux(obj1)).then(() => {
            toast.success("Contact added successfully"); //when uncomments this line when proper response comes from server .
          });
        }, 3000);
      })
      .catch((error) => {
        console.error("Failed to add contact:", error);
        toast.error("Failed to add contact");
      });
  };

  const HandleUpdateUdf = async () => {
    if (udfFieldChange.length > 0) {
      udfFieldChange.forEach((udf) => {
        let ProjectId = udf.folderId;

        if (udf.field.length > 0) {
          let ClientUDFString = udf.field
            .map((udfField) => {
              // Only include fields that have a valid UdfValue
              if (udfField?.UdfValue) {
                console.log(udfField, "=== udfField");

                return `${udfField?.UserDefFieldID}_${
                  udfField?.UserDefFieldTypeID
                }_${
                  udfField?.TextControlValue
                }_UDF:${udfField?.UdfValue.trim()}`;
              }
              return null; // Return null for fields that don't meet the condition
            })
            .filter(Boolean) // Remove null or undefined values
            .join(","); // Join the array into a single string separated by commas
          let udfBody = {
            OriginatorNo: CompanyFormData?.ID,
            ProjectId,
            ClientUDFString: ClientUDFString,
            ContactUDFString: "",
            ContactNo: "",
          };

          dispatch(
            ad_Json_CRMSaveUDFValues_Action(udfBody, (res) => {
              // console.log(res, "===== res");
            })
          );
        }
      });
    }
    // dispatch(
    //   ad_Json_GetClientCardDetails_Action(body, (res) => {
    //     setCompanyDetailData(res?.Table1?.[0]);
    //     setAllAddressData(res?.Table2);
    //     setAllClientCardData(res);
    //   })
    // );
  };

  const handleClose = () => {
    dispatch(setOpenCompanyModal(false));
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="custom-modal modal-lg"
        fullWidth={true}
        maxWidth={"lg"}
      >
        <Box className="d-flex align-items-center justify-content-between modal-head">
          <Box className="clearfix">
            <DialogTitle>Create Company </DialogTitle>
          </Box>

          {/*  */}
          <Button onClick={handleClose} autoFocus>
            <CloseIcon />
          </Button>
        </Box>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <CreateNewComoany
              handleClose={handleClose}
              setCompanyFormData={setCompanyFormData}
              setContactFormData={setContactFormData}
              setAllAddressData={setAllAddressData}
              setUdfFieldChange={setUdfFieldChange}
              setCompanyDetailData={setCompanyDetailData}
              setAllClientCardData={setAllClientCardData}
              CompanyFormData={CompanyFormData}
              contactFormData={contactFormData}
              allAddressData={allAddressData}
              udfFieldChange={udfFieldChange}
              companyDetailData={companyDetailData}
              allClientCardData={allClientCardData}
            />
          </DialogContentText>
        </DialogContent>

        <DialogActions className="pt-4 px-0">
          <Box className="mt-4 mb-2 d-flex">
            <Button
              onClick={HandleCompanyUpdate}
              autoFocus
              variant="outlined"
              className="btn-blue me-2"
              startIcon={<CreateIcon />}
            >
              Create Company
            </Button>
            <Button
              onClick={handleClose}
              className="btn-red"
              variant=""
              startIcon={<CloseIcon />}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
